import './index.scss'
import React from 'react'
import {simpleFormat} from 'lib/util'

// 我们的团队
const Pricing = (props) => {
  //
  return [{
    uid: 'pricing-1',
    html:(
      <div className={"section-pricing"}>
        <div className="container">
          {!props.title.is_hidden && <h2 className="section-title">{props.title.content}</h2>}
          {
            !props.paragraph.is_hidden &&
            <div className="section-description">
              {props.paragraph.content}
            </div>
          }

          <div className="row section-pricing-wrap">
            {props.list.items.length === 2 && <div className="col-sm-2"> </div>}
            {props.list.items.map((item, index) =>
              <div className="col-sm-4" key={index}>
                <div className={`pricing-item-wrap pricing-item-${index}`}>
                  <div className="pricing-heading">
                    <div className="pricing-title">{ item.title.content }</div>
                    <div className="pricing-price"
                         dangerouslySetInnerHTML={{__html: item.subtitle.content.replace(/(\d)/g, '<span class="number">$1</span>')}}>
                    </div>
                  </div>
                  <ul className="list-pricing-features">
                    {item.description.content.map((feature, i) =>
                      <li key={i}>
                        {feature}
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}
            {props.list.items.length === 2 && <div className="col-sm-2"> </div>}
          </div>
        </div>
      </div>
    )
  }]
}

export default Pricing


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/pricing/index.js